import { render, staticRenderFns } from "./app_iphone.vue?vue&type=template&id=e1633892&scoped=true&"
import script from "./app_iphone.vue?vue&type=script&lang=js&"
export * from "./app_iphone.vue?vue&type=script&lang=js&"
import style0 from "./app_iphone.vue?vue&type=style&index=0&id=e1633892&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1633892",
  null
  
)

export default component.exports